import "../assets/Text.css";
import { ref as X, computed as c, defineComponent as H, openBlock as g, createElementBlock as f, normalizeClass as Z, unref as h, normalizeStyle as $, withModifiers as ee, createCommentVNode as w, createElementVNode as k, toDisplayString as te, createVNode as ne, Fragment as oe, renderList as ae, createBlock as se } from "vue";
import { d as ie } from "./debounce.BDLEW31m.js";
import { S as re } from "./widgets-core.es.Dphhb0qH.js";
import { j as r, A as m, e as s, k as j, f as S, l as v, D as C, m as ue, T as G } from "./maps.DxC18PqJ.js";
import { o as le, d as z, f as de, n as I, B as D } from "./useStore.CDG6wbfK.js";
function pe(n) {
  return n && n.length ? n[0] : void 0;
}
const ce = {
  [r.ApplyPromoCode]: m.ApplyDiscount,
  [r.CloseTool]: m.NoAction,
  [r.EmailCapture]: m.SendSubscribe,
  emailCapture: m.SendSubscribe,
  [r.SendForm]: m.SendForm,
  [r.OpenUrl]: m.OpenUri,
  [r.CallPhoneNumber]: m.OpenUri,
  [r.OpenMailClient]: m.OpenUri,
  [r.SavedSearch]: m.SendSaveSearch,
  savedSearch: m.SendSaveSearch,
  [r.OpenBookingEngine]: m.OpenBookingEngine,
  [r.LastSearch]: m.OpenBookingEngine
};
function O(n) {
  return ce[n];
}
const F = le();
let N = 0;
function me() {
  return N += 1, `extra-modules-${N}`;
}
function E(n) {
  const e = F.getLiteral(n), t = {
    [F.language]: e
  };
  return {
    sync: !0,
    id: me(),
    mobile: t,
    desktop: t
  };
}
function _(n = "") {
  return {
    ...E(n),
    moduleType: s.Heading
  };
}
function x(n = "") {
  return {
    ...E(n),
    moduleType: s.Paragraph
  };
}
function L(n, e) {
  return {
    ...E(e),
    moduleType: s.Button,
    behaviour: {
      type: n
    }
  };
}
const ye = {
  [s.EmailCapture]: "Your email address has been successfully added to our list.",
  [s.SavedSearch]: "We will send you an email with your search very soon.",
  [s.Form]: "We have received your form submission correctly"
}, W = {
  [r.ApplyPromoCode]: "Apply promocode",
  [r.OpenUrl]: "Continue",
  [r.CloseTool]: "Close",
  [r.OpenBookingEngine]: "Book Now",
  [r.OpenMailClient]: "Contact Now",
  [r.CallPhoneNumber]: "Call Now"
}, V = X(), ge = [
  s.SavedSearch,
  s.EmailCapture,
  s.Form,
  s.Login
];
function he(n) {
  var e;
  return ((e = n.find(
    (t) => ge.includes(t.moduleType)
  )) == null ? void 0 : e.moduleType) || "";
}
function A(n) {
  var e;
  return (e = n.find(
    (t) => t.moduleType === s.Button
  )) == null ? void 0 : e.behaviour.type;
}
function fe(n, e) {
  return n.filter((t) => {
    if (t.moduleType !== s.Button) return !1;
    const a = t;
    return a.kind === j.Secondary && a.primaryButtonId === e;
  });
}
function Se(n) {
  return n.reduce((e, t) => {
    var i;
    if (t.moduleType !== s.Button) return [...e, t];
    if (t.kind === j.Secondary) return e;
    const l = fe(n, t.id);
    return [...e, {
      ...t,
      alignment: (i = pe(l)) == null ? void 0 : i.alignment,
      secondaryButtons: l
    }];
  }, []);
}
function we(n) {
  const e = Se(n), t = {
    [S.Main]: e
  }, a = he(e), l = e.find(
    (B) => B.moduleType === s.Login
  );
  if (!a) return t;
  if (l) {
    const B = e.find(
      (p) => p.moduleType === s.Button
    );
    if (t[S.Main] = e.reduce((p, u) => u.moduleType === s.Button ? p : u.moduleType === s.Login ? [
      ...p,
      {
        ...u,
        buttonModule: B,
        currentView: v.LoginRegister
      }
    ] : [...p, u], []), t[v.LoginSignin] = e.reduce((p, u) => u.moduleType !== s.Login ? p : u.moduleType === s.Login ? [
      ...p,
      {
        ...u,
        buttonModule: B,
        currentView: v.LoginSignin
      }
    ] : [...p, u], []), !a)
      return t;
    const K = A(e), R = W[K] || "Close";
    t[v.LoginSuccess] = e.reduce((p, u) => u.moduleType !== s.Login && u.moduleType !== s.Button ? p : u.moduleType === s.Button ? [
      ...p,
      {
        ...L(K, R)
      }
    ] : u.moduleType === s.Login ? [
      ...p,
      {
        ...u,
        currentView: v.LoginSuccess
      }
    ] : [...p, u], []);
    const Y = c(() => _("There has been an error.")), J = c(() => x("Something went wrong. Please, try again later.")), Q = c(() => L(r.GoMainStep, "Back"));
    return t[S.Failure] = [
      Y.value,
      J.value,
      Q.value
    ], t;
  }
  const d = A(e), i = W[d] || "Close", o = c(() => _("Thank you!")), y = c(() => x(
    ye[a]
  )), T = c(
    () => L(d, i)
  ), P = c(() => _("There has been an error.")), M = c(() => x("Something went wrong. Please, try again later.")), b = c(() => L(r.GoMainStep, "Back"));
  return t[S.Success] = [
    o.value,
    y.value,
    T.value
  ], t[S.Failure] = [
    P.value,
    M.value,
    b.value
  ], A(e) === "submit" && (t[S.Success].pop(), t[S.Failure].pop()), t;
}
const Te = {
  fontSize: 16,
  lineHeight: 16,
  letterSpacing: 0
};
function q(n = Te, e = C.Desktop, t) {
  const {
    fontSize: a,
    lineHeight: l,
    letterSpacing: d
  } = n;
  let i;
  e === C.Desktop && t === ue.Compact ? i = 0.865 : e === C.Mobile ? i = 0.8 : i = 1;
  const o = Math.round(a * i), y = Math.round(l), T = (d ?? 0) / 100;
  return {
    fontSize: z(o),
    lineHeight: z(y),
    letterSpacing: d ? de(T) : "normal"
  };
}
const be = ["button-state", "moduleType", "data-module-id", "data-full-width"], ke = {
  key: 0,
  class: "thn--tool-button__back",
  "aria-hidden": "true"
}, ve = ["innerHTML"], Pe = ["innerHTML"], Me = {
  key: 3,
  class: "thn--tool-button__sending loader"
}, Be = { class: "sr-only" }, U = /* @__PURE__ */ H({
  __name: "Button",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    isLinkLayout: { type: Boolean },
    isSecondary: { type: Boolean },
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = I(), { t } = re(), a = n, l = c(() => {
      var o;
      return e == null ? void 0 : e.literals.getActiveModuleText(
        a.moduleProps,
        ((o = e == null ? void 0 : e.styles.fonts[a.moduleProps.moduleType]) == null ? void 0 : o.textTransform) === G.Titlecase,
        {
          candidates: e.extraData.dynamicTags,
          replacement: e.extraData.tokens
        }
      );
    }), d = c(
      () => {
        var o;
        return q(
          a.moduleProps.appearance,
          e == null ? void 0 : e.device,
          (o = a.layout) == null ? void 0 : o.size
        );
      }
    ), i = ie(() => {
      if ((e == null ? void 0 : e.handlers.buttonState) !== D.Sending)
        if (a.hasExtraSteps && !a.moduleProps.id.includes("extra"))
          V.value && (V.value.scrollTop = 0), e == null || e.handlers.callHandler(O(a.hasExtraSteps));
        else if (a.moduleProps.behaviour.type === r.GoMainStep)
          e == null || e.handlers.goBackToMainStep();
        else {
          const o = O(a.moduleProps.behaviour.type);
          e == null || e.handlers.callHandler(o, a.moduleProps.id);
        }
    }, 200, { leading: !0, trailing: !1 });
    return (o, y) => {
      var T, P, M;
      return g(), f("button", {
        class: Z([
          "thn--tool-button",
          {
            "inline-layout": o.isLinkLayout,
            "thn--tool-button__secondary": o.isSecondary
          }
        ]),
        "button-state": (T = h(e)) == null ? void 0 : T.handlers.buttonState,
        style: $(d.value),
        moduleType: o.moduleProps.moduleType,
        "data-module-id": o.moduleProps.id,
        "data-full-width": (P = o.moduleProps.appearance) == null ? void 0 : P.fullWidth,
        onMousedown: y[0] || (y[0] = ee(
          //@ts-ignore
          (...b) => h(i) && h(i)(...b),
          ["left"]
        )),
        onClick: y[1] || (y[1] = //@ts-ignore
        (...b) => h(i) && h(i)(...b))
      }, [
        o.isLinkLayout ? w("", !0) : (g(), f("div", ke)),
        o.isLinkLayout ? (g(), f("span", {
          key: 2,
          innerHTML: l.value
        }, null, 8, Pe)) : (g(), f("div", {
          key: 1,
          class: "thn--tool-button__label",
          innerHTML: l.value
        }, null, 8, ve)),
        ((M = h(e)) == null ? void 0 : M.handlers.buttonState) === h(D).Sending && !o.isLinkLayout ? (g(), f("div", Me, [
          k("span", Be, te(h(t)("Sending")), 1),
          y[2] || (y[2] = k("div", { class: "la-ball-pulse" }, [
            k("div", { "aria-hidden": "true" }),
            k("div", { "aria-hidden": "true" }),
            k("div", { "aria-hidden": "true" })
          ], -1))
        ])) : w("", !0)
      ], 46, be);
    };
  }
}), Le = ["data-button-alignment"], ze = /* @__PURE__ */ H({
  __name: "CTAGroup",
  props: {
    moduleProps: {},
    hasExtraSteps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = n;
    return (t, a) => {
      var l;
      return g(), f("div", {
        class: "thn--tool-cta-group",
        "data-button-alignment": e.moduleProps.alignment ?? "horizontal"
      }, [
        ne(U, {
          "has-extra-steps": e.hasExtraSteps,
          "tool-kind": e.toolKind,
          layout: e.layout,
          "is-link-layout": ((l = e.moduleProps.appearance) == null ? void 0 : l.layout) === "link",
          "module-props": e.moduleProps
        }, null, 8, ["has-extra-steps", "tool-kind", "layout", "is-link-layout", "module-props"]),
        (g(!0), f(oe, null, ae(t.moduleProps.secondaryButtons, (d) => {
          var i;
          return g(), se(U, {
            key: d.id,
            "has-extra-steps": e.hasExtraSteps,
            "tool-kind": e.toolKind,
            "is-link-layout": ((i = d.appearance) == null ? void 0 : i.layout) === "link",
            "is-secondary": !0,
            layout: e.layout,
            "module-props": d
          }, null, 8, ["has-extra-steps", "tool-kind", "is-link-layout", "layout", "module-props"]);
        }), 128))
      ], 8, Le);
    };
  }
}), Ce = ["innerHTML", "moduleType", "data-module-id"], De = /* @__PURE__ */ H({
  __name: "Text",
  props: {
    moduleProps: {},
    toolKind: {},
    layout: {}
  },
  setup(n) {
    const e = {
      [s.Heading]: {
        fontSize: 24,
        lineHeight: 24
      },
      [s.Paragraph]: {
        fontSize: 16,
        lineHeight: 16
      },
      [s.Button]: {
        fontSize: 18,
        lineHeight: 18
      }
    }, t = I(), a = n, l = c(() => {
      var o;
      return t == null ? void 0 : t.literals.getActiveModuleText(
        a.moduleProps,
        ((o = t == null ? void 0 : t.styles.fonts[a.moduleProps.moduleType]) == null ? void 0 : o.textTransform) === G.Titlecase,
        {
          candidates: t.extraData.dynamicTags,
          replacement: t.extraData.tokens
        }
      );
    }), d = c(
      () => a.moduleProps.appearance || e[a.moduleProps.moduleType]
    ), i = c(
      () => {
        var o;
        return q(d.value, t == null ? void 0 : t.device, (o = a.layout) == null ? void 0 : o.size);
      }
    );
    return (o, y) => (g(), f("div", {
      class: "thn--tool-text",
      style: $(i.value),
      innerHTML: l.value,
      moduleType: o.moduleProps.moduleType,
      "data-module-id": o.moduleProps.id
    }, null, 12, Ce));
  }
});
export {
  De as _,
  q as a,
  ze as b,
  Se as c,
  U as d,
  O as g,
  he as h,
  V as s,
  we as u
};
//# sourceMappingURL=Text.vue_vue_type_style_index_0_lang.CqNxQPnN.js.map
